// extracted by mini-css-extract-plugin
export default {"fields":"dA0T0JyL0RRnMpTcaEuw"};